import {Component, Input} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {environment} from '../../../../environments/environment';

function createAzureMapsUrl(position: [longitude: number, latitude: number]|null, width: number, height: number): URL {
    const url = new URL('https://atlas.microsoft.com/map/static/png');
    const searchParams = url.searchParams;
    const vwConcernPos = [5.4382772, 52.1901149];

    searchParams.append('subscription-key', environment.azureApiKey);
    searchParams.append('api-version', '1.0');
    searchParams.append('layer', 'basic');
    searchParams.append('style', 'main');
    searchParams.append('zoom', '14');
    searchParams.append('width', `${width}`);
    searchParams.append('height', `${height}`);
    searchParams.append('language', 'nl-NL');
    searchParams.append('center', (position || vwConcernPos).join(','));

    return url;
}

export function buildAzureMapsSrcset(position: [longitude: number, latitude: number]|null): string {
    return [
        `${createAzureMapsUrl(position, 333, 240).toString()} 1x`,
        `${createAzureMapsUrl(position, 666, 480).toString()} 2x`,
        `${createAzureMapsUrl(position, 999, 720).toString()} 3x`,
    ].join(',');
}

@Component({
    selector: 'app-mini-map',
    templateUrl: './mini-map.component.html',
    standalone: false
})
export class MiniMapComponent {
    private urlSubject = new BehaviorSubject<string>(buildAzureMapsSrcset(null));
    srcset$ = this.urlSubject.asObservable();

    @Input() city = '';
    @Input() address = '';

    @Input() set center(position: [longitude: number, latitude: number]|null) {
        this.urlSubject.next(buildAzureMapsSrcset(position));
    }
}
